// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2QSLz","list":"BalanceDue_list__3hdby","listRow":"BalanceDue_listRow__2-Gv6","total":"BalanceDue_total__yfODV"};